// What an info-view perceptual-mapping chart is, resolved from the view the report author placed:
// which sub-mode of the question block it draws, which side its tv chart plots by, and the fact
// that it never offers the question's own filters.

const VIEW_MODES = { mds: 'm', entities: 't', attributes: 't', quadrant: 'q' }

// A quadrant question has only its quadrant to show, whatever view the chart names.
export const resolveView = ({ type, view } = {}) => ('qa' === type ? 'quadrant' : view)

// null for a view that names no sub-mode - there is then nothing to draw.
export const resolveMode = (params = {}) => VIEW_MODES[resolveView(params)] || null

// The tv sub-mode is reached through two views, which differ only in the side they plot by.
export const resolvePlotBy = ({ defaultPlotByValue, ...params } = {}) => {
  const view = resolveView(params)

  return 't' === VIEW_MODES[view] ? view[0] : defaultPlotByValue
}

// The chart is a fixed placement in a report, so its filters are off unless the author asked
// for them.
export const resolveComponents = components => ({ controls: false, ...components })
